import { observer } from 'mobx-react-lite'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import { useStore } from 'store/useStore'
import { EmployeeKeys } from 'sections/LKSection/modules/EmployeeModule/data'
import { setRolesOnSomePvz } from 'sections/LKSection/modules/EmployeeModule/utils/setRolesOnSomePvz'
import { Padding } from 'components/ui'
import { Flex, Input, Modal, Text, Title } from 'components/uiKit'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'

import { EmployeeRoleItem } from './EmployeeRoleItem/EmployeeRoleItem'

import shop from 'assets/img/lk-section/Employee/Shop.png'

const getKey = (key: string) => `${EmployeeKeys.addEmployeePage}.${key}`

type AddEmployeeToSomePvzModalProps = {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
}

export const AddEmployeeToSomePvzModal = observer(({ setIsModalOpen }: AddEmployeeToSomePvzModalProps) => {
  const { viewEmployeeUiStore: uiStore } = useStore()

  const { t } = useTranslation()

  const saveButtonHandler = () => {
    setRolesOnSomePvz(uiStore)
    setIsModalOpen(false)
  }

  const cancelButtonHandler = () => {
    uiStore.employeeRoleList.forEach((roleItem) => {
      roleItem.setRoleWasChangedInModal(false)
      roleItem.setRole(roleItem.cachedRole)
    })

    uiStore.setELockRoleList([])

    setIsModalOpen(false)
  }

  return (
    <Modal
      title={t(getKey('Выбор ПВЗ'))}
      open={true}
      onOk={saveButtonHandler}
      okText={t(getSharedKey('save'))}
      cancelText={t(getSharedKey('reset'))}
      onCancel={cancelButtonHandler}
      width={800}
      maskClosable={false}
      closable={false}
    >
      <Padding py={16}>
        <Input
          allowClear
          placeholder={t(getKey('Найти адрес'))}
          value={uiStore.search}
          onChange={(e) => uiStore.setSearch(e.target.value)}
        />
      </Padding>

      <Flex vertical style={{ overflowY: 'scroll', height: 600 }}>
        {uiStore.employeeRoleList.length > 0 ? (
          <Padding pr={16}>
            {uiStore.employeeRoleList.map((employeeRole) => (
              <EmployeeRoleItem key={employeeRole.id} employeeRole={employeeRole} />
            ))}
          </Padding>
        ) : (
          <Flex style={{ height: '100%' }} justify="center" align="center">
            <Flex vertical align="center" gap={12}>
              <img src={shop} />
              <Title level={5}>{t(getKey('Пункт выдачи не найден'))}</Title>
              <Text style={{ textAlign: 'center' }}>{t(getKey('Проверьте, нет ли ошибок в тексте'))}</Text>
            </Flex>
          </Flex>
        )}
      </Flex>
    </Modal>
  )
})
